import React from "react";
import Inbox from "components/backend/inbox/index";

export default class InboxArchive extends React.Component {
  render() {
    return <Inbox status="archived" {...this.props} />;
  }
}
